import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const getCount = (state: RootState) => state.pages.editor.canvas.successRequestCount;

const getSuccessRequestCount = createSelector([getCount], (count) => count);

export default getSuccessRequestCount;
